module.exports = __webpack_public_path__ + "static/media/contact.068b1c34.svg";